import React from "react";
import LoginCard from "../Components/Login/LoginCard";
import Footer from "../Components/Footer";
import LifeDocLogoWhite from "../Assets/LifeDlogoWhite.png";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import ArrowBackRoundedIcon from "@material-ui/icons/ArrowBackRounded";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.palette.primary.main,
    height: "105vh",
    maxWidth: "100vw",
  },
  backButton: {
    color: theme.palette.common.white,
    height: 50,
    width: 50,
    transition: theme.transitions.create(["transform"], {
      duration: theme.transitions.duration.complex,
    }),
    "&:hover": {
      transform: "translateX(20px)",
    },
  },
}));

const Login = () => {
  const classes = useStyles();

  return (
    <Container className={classes.root}>
      <a href="/">
        <ArrowBackRoundedIcon className={classes.backButton} />
      </a>

      <Grid
        container
        spacing={2}
        direction="column"
        justify="center"
        alignItems="center"
      >
        <Grid item lg={12}>
          <LoginCard />
        </Grid>

        <Grid item lg={12}>
          <Footer logo={LifeDocLogoWhite} textColor="white" />
        </Grid>
      </Grid>
    </Container>
  );
};
export default Login;
